import type { ResearchMode } from '@/types';

/** What a Quick list leaves out, in the words shown on the start screen. Everything else
 * (descriptions, Apollo, size and the fit check) runs as in full research. A Quick list reads
 * each company's home page directly ("fast scraping"); full research reads deeper. */
export const QUICK_LIST_LEAVES_OUT = [
  'Your own questions about each company',
  'Ownership details',
  'Acquisition history',
  'Recent news',
  'Readiness and buyer-likelihood scores',
] as const;

export const RESEARCH_MODE_LABEL: Record<ResearchMode, string> = {
  quick: 'Quick list',
  full: 'Full research',
};

export function isQuickList(mode: ResearchMode | '' | undefined): boolean {
  return mode === 'quick';
}

/** The list type saved on a run (either key casing). Lists made before the choice existed were
 * full research. */
export function researchModeOf(filters: unknown): ResearchMode {
  const f = (filters ?? {}) as Record<string, unknown>;
  return f.researchMode === 'quick' || f.research_mode === 'quick' ? 'quick' : 'full';
}
